import { PopoverOrigin } from "@material-ui/core/Popover";

export const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: "top",
  horizontal: "left",
};

export const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};

export const LINK_LIST_WIDTHS = {
  rxStrategy: "220px",
};
